import { PortalPage } from "../../components/portal/PortalPage";
import { ClientNotificationSettings } from "../../components/portal/ClientNotificationSettings";

export default function ClientNotificationSettingsPage() {
  return (
    <PortalPage title="Notification preferences" subtitle="Choose what we tell you about and how emails reach you — instantly, as a daily summary, or held during quiet hours. Each person on your team sets their own."
                back={{ to: "/portal/settings", label: "Back to settings" }} testid="client-notification-settings">
      <div className="max-w-3xl">
        <ClientNotificationSettings />
      </div>
    </PortalPage>
  );
}
